import * as React from "react";
import { db } from "../../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { Box, List, Stack } from "@mui/material";
import CategoryItem from "./CategoryItem";
import CategoryModal from "./CategoryModal";
import SubCategoryModal from "./SubCategoryModal";

export default function CategoryList() {
  const topCategoryRef = collection(db, "heading");

  // const [category, setCategory] = useState([]);
  const [tCategory, setTCategory] = useState([]);

  // const categoryRef = query(
  //   collection(db, "category"),
  //   where("parent", "==", "v2ujqRLKHXDi1hPYQuDK")
  // );

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    // get headings docs
    onSnapshot(topCategoryRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setTCategory(data);
    });

    // getDocs(categoryRef).then((snapshot) => {
    //   const data = snapshot.docs.map((doc) => ({
    //     ...doc.data(),
    //     id: doc.id,
    //   }));
    //   setCategory(data);
    // });
  }, []);

  return (
    <div>
      <h2>Categories</h2>

      <Stack direction="row" spacing={2}>
        <CategoryModal />
        <SubCategoryModal />
      </Stack>

      {/* <div>
        <ul>
          {category.map((value, key) => (
            <MenuItem value={value.id}>{value.name}</MenuItem>
          ))}
        </ul>
      </div> */}
      <Box sx={{ width: "70%", border: "1px solid grey", borderRadius: 3 }}>
        <List>
          {tCategory.map((value, key) => (
            <CategoryItem key={key} value={value} />
          ))}

          {/* set collapse list */}
        </List>
      </Box>
    </div>
  );
}
